module.exports = __webpack_public_path__ + "img/impresiones.38c1943d.svg";